<template>
	<div style="padding-bottom: 24rem;">
		<el-form ref="teacherInfoForm" :model="teacherInfo" :rules="rules" label-position="left" label-width="110rem" style="padding-bottom: 24rem">
			<div class="teacher-info">
				<div class="base-info">
					<div style="display: flex; align-items: center; margin-bottom: 24rem">
						<el-image :src="jcxx" style="width: 24rem; height: 24rem"></el-image>
						<div style="font-weight: 600; font-size: 24rem; color: #1e3aa2; flex: 1; margin-left: 14rem">基础信息</div>
						<!--          <el-image :src="xjList[0]" style="width: 158rem; height: 36rem"></el-image>-->
					</div>
					<div class="avatar">
						<el-image
							:src="teacherInfo.photo == null || teacherInfo.photo == '' ? img_ : teacherInfo.photo"
							style="width: 100rem; height: 100rem; border-radius: 100rem; margin-right: 40rem"></el-image>
						<div style="font-weight: 600; font-size: 32rem; color: #2b3541; margin-right: 12rem">{{ teacherInfo.clerk_name }}</div>
						<el-image v-if="teacherInfo.gender === 2" :fit="fit" :src="$OssAddress + 'imgs/nan.svg'" style="width: 24rem; height: 24rem"></el-image>
						<el-image v-if="teacherInfo.gender === 1" :fit="fit" :src="$OssAddress + 'imgs/nv.svg'" style="width: 24rem; height: 24rem"></el-image>
						<div style="flex: 1"></div>
						<div style="display: flex; align-items: center; margin-right: 193rem">
							<el-form-item label="当前星级" prop="star_rating" required="true">
								<el-select v-model="teacherInfo.star_rating" placeholder="请选择星级" style="width: 200rem">
									<el-option v-for="item in star_type" :key="item.value" :label="item.label" :value="item.value"></el-option>
								</el-select>
							</el-form-item>
						</div>
					</div>
					<div class="info">
						<div class="vitae">
							<el-form-item label="所属校区">
								{{ teacherInfo.school }}
							</el-form-item>
							<el-form-item label="教学岗位">{{ teacherInfo.role_type }}/{{ teacherInfo.current_role }}</el-form-item>
							<el-form-item label="教学学科">{{ teacherInfo.p_subject }}/{{ teacherInfo.subject }}</el-form-item>
							<el-form-item label="年龄">{{ teacherInfo.age }}</el-form-item>
							<el-form-item label="民族">{{ teacherInfo.nation_text }}</el-form-item>
							<el-form-item label="是否为班主任">{{ teacherInfo.class }}</el-form-item>
							<el-form-item label="出生日期">{{ teacherInfo.birthday }}</el-form-item>
							<el-form-item label="入职时间">{{ teacherInfo.entry_time }}</el-form-item>
							<el-form-item label="教龄" prop="teaching_experience" required="true">
								<el-input
									v-model.number="teacherInfo.teaching_experience"
									placeholder="请输入教龄"
									type="number"
									@input="
										(val) => {
											teacherInfo.teaching_experience = Math.min(100, Math.max(0, val))
										}
									" />
							</el-form-item>
							<div class="row">
								<el-form-item label="政治面貌" prop="political_outlook" required="true">
									<el-select v-model="teacherInfo.political_outlook" placeholder="请选择政治面貌">
										<el-option v-for="item in political_type" :key="item.political_id" :label="item.political_outlook" :value="item.political_id"></el-option>
									</el-select>
								</el-form-item>
							</div>
							<div class="row">
								<el-form-item label="任职情况" prop="employment" required="true">
									<el-select v-model="teacherInfo.employment" placeholder="请选择任职情况">
										<el-option v-for="item in teacherEmployment" :key="item" :label="item" :value="item"></el-option>
									</el-select>
								</el-form-item>
							</div>
							<div class="row">
								<el-form-item label="联系方式" prop="mobile" required="true">
									<el-input v-model.number="teacherInfo.mobile" maxlength="11" placeholder="请输入联系方式" />
								</el-form-item>
							</div>
						</div>
					</div>
				</div>
			</div>

			<div class="credentials">
				<div class="credentials-item" style="width: 460rem; background: #ffffff; border-radius: 8rem">
					<div style="display: flex; align-items: center">
						<el-image :src="zy" style="width: 24rem; height: 24rem"></el-image>
						<div style="font-weight: 600; font-size: 24rem; color: #1e3aa2; flex: 1; margin-left: 14rem">专业及院校</div>
					</div>
					<div style="margin-top: 20rem; display: grid; grid-template-columns: 1fr 1fr; gap: 24rem">
						<div style="display: flex">
							<el-form-item label="最高学历" prop="education" required="true">
								<el-select v-model="teacherInfo.education" placeholder="请选择最高学历">
									<el-option v-for="item in educationLevels" :key="item.value" :label="item.label" :value="item.value"></el-option>
								</el-select>
							</el-form-item>
						</div>
						<div style="display: flex">
							<el-form-item label="是否师范专业" prop="is_normal" required="true">
								<el-select v-model="teacherInfo.is_normal" placeholder="是否为师范专业">
									<el-option :value="1" label="是">是</el-option>
									<el-option :value="0" label="否">否</el-option>
								</el-select>
							</el-form-item>
						</div>
						<div style="display: flex">
							<el-form-item label="毕业院校" prop="graduated_from" required="true">
								<el-input v-model="teacherInfo.graduated_from" maxlength="20" placeholder="请输入毕业院校" style="width: 220rem !important" type="text" />
							</el-form-item>
						</div>
						<div style="display: flex">
							<el-form-item label="所学专业" prop="major" required="true">
								<div style="width: 220rem !important">
									<el-input v-model="teacherInfo.major" maxlength="20" placeholder="请输入所学专业" style="width: 220rem !important" type="text" />
								</div>
							</el-form-item>
						</div>
					</div>
				</div>
				<div style="width: 24rem"></div>
				<div class="credentials-item" style="width: 460rem; background: #ffffff; border-radius: 8rem">
					<div style="display: flex; align-items: center">
						<el-image :src="zc" style="width: 24rem; height: 24rem"></el-image>
						<div style="font-weight: 600; font-size: 24rem; color: #1e3aa2; flex: 1; margin-left: 14rem">职称及证书</div>
					</div>
					<div style="margin-top: 20rem; display: grid; grid-template-columns: 1fr 1fr; gap: 24rem; gap: 30rem">
						<div style="display: flex">
							<el-form-item label="是否有资格证" prop="teacher_certificate" required="true">
								<el-select v-model="teacherInfo.teacher_certificate" placeholder="请选择是否有教师资格证">
									<el-option :value="1" label="是">是</el-option>
									<el-option :value="0" label="否">否</el-option>
								</el-select>
							</el-form-item>
						</div>
						<div style="display: flex">
							<el-form-item label="教师职称" prop="teacher_title" required="true">
								<el-select v-model="teacherInfo.teacher_title" placeholder="请选择教师职称">
									<el-option v-for="item in teacherTitle" :key="item" :label="item" :value="item"></el-option>
								</el-select>
							</el-form-item>
						</div>
					</div>
				</div>
			</div>
		</el-form>

		<div style="display: flex; justify-content: space-between;">
			<div class="echarts-radar-box">
				<div style="display: flex; align-items: center">
					<el-image :src="czpg" style="width: 24rem; height: 24rem"></el-image>
					<div style="font-weight: 600; font-size: 24rem; color: #1e3aa2; flex: 1; margin-left: 14rem">{{ new Date(teacherInfo.month).getMonth() + 1 }}月成长评估</div>
					<el-date-picker
						v-model="teacherInfo.month"
						:picker-options="pickerOptions"
						placeholder="选择日期"
						type="month"
						value-format="yyyy MM"
						@change="changeMonth"
						style="width: 270rem; margin-right: 30rem" />
				</div>
				<el-form ref="monthRecord" :model="monthRecord" class="info" label-position="left" label-width="80rem">
					<div class="vitae">
						<el-form-item label="工作态度" prop="work_attitude">
							<el-input v-model="monthRecord.work_attitude" placeholder="请输入工作态度" type="text" @input="(val) => handleIntegerInput('work_attitude', val)" />
						</el-form-item>
						<el-form-item label="备课反思" prop="lesson_preparation">
							<el-input v-model="monthRecord.lesson_preparation" placeholder="请输入备课反思" type="text" @input="(val) => handleIntegerInput('lesson_preparation', val)" />
						</el-form-item>
						<el-form-item label="教学能力" prop="teaching">
							<el-input v-model="monthRecord.teaching" placeholder="请输入教学能力" type="text" @input="(val) => handleIntegerInput('teaching', val)" />
						</el-form-item>
						<el-form-item label="学科辅导" prop="discipline">
							<el-input v-model="monthRecord.discipline" placeholder="请输入学科辅导" type="text" @input="(val) => handleIntegerInput('discipline', val)" />
						</el-form-item>
						<el-form-item label="学科素养" prop="subject_literacy">
							<el-input v-model="monthRecord.subject_literacy" placeholder="请输入学科素养" type="text" @input="(val) => handleIntegerInput('subject_literacy', val)" />
						</el-form-item>
						<el-form-item label="育人能力" prop="educate">
							<el-input v-model="monthRecord.educate" placeholder="请输入育人能力" type="text" @input="(val) => handleIntegerInput('educate', val)" />
						</el-form-item>
						<el-form-item label="最终得分">
							<div class="final-score">{{ finalScore }}</div>
						</el-form-item>
						<el-form-item label="等级">
							<div class="level">{{ level }}</div>
						</el-form-item>
					</div>
				</el-form>
				<!-- <t-result imgStyle="width: 200rem !important;" text="暂无数据" type='empty'></t-result> -->
			</div>

			<div class="history-evaluation-record">
				<div style="display: flex; align-items: center">
					<el-image :src="ls" style="width: 24rem; height: 24rem"></el-image>
					<div style="font-weight: 600; font-size: 24rem; color: #1e3aa2; flex: 1; margin-left: 14rem">历史评估记录</div>
					<el-date-picker v-model="year" :picker-options="yearPickerOptions" placeholder="选择日期" type="year" value-format="yyyy" @change="changeYear" style="width: 270rem; margin-left: 80rem" />
				</div>
				<div>
					<div style="height: 34rem; background: #aac4ff; margin-top: 18rem; display: flex; align-items: center; justify-content: center">
						<div style="flex: 1; text-align: center; font-weight: 400; font-size: 14rem; color: #1e3aa2">月份</div>
						<div style="flex: 1; text-align: center; font-weight: 400; font-size: 14rem; color: #1e3aa2">等级</div>
						<div style="flex: 1; text-align: center; font-weight: 400; font-size: 14rem; color: #1e3aa2">最终得分</div>
						<div style="flex: 1; text-align: center; font-weight: 400; font-size: 14rem; color: #1e3aa2">相较于上月</div>
					</div>
					<div style="height: 134rem; overflow-y: auto">
						<div v-for="i in yearRecord" :key="i" style="height: 34rem; display: flex; align-items: center; justify-content: center">
							<div style="flex: 1; text-align: center; font-weight: 400; font-size: 14rem; color: #3c3c3c">{{ i.month }}</div>
							<div style="flex: 1; text-align: center; font-weight: 400; font-size: 14rem; color: #3c3c3c">{{ i.level }}</div>
							<div style="flex: 1; text-align: center; font-weight: 400; font-size: 14rem; color: #3c3c3c">{{ i.final }}</div>
							<div style="flex: 1; text-align: center; font-weight: 400; font-size: 14rem; color: #3c3c3c; display: flex; align-items: center; justify-content: center">
								<el-image
									v-if="Number(i.compared) > 0 || Number(i.compared) < 0"
									:src="Number(i.compared) > 0 ? up : Number(i.compared) < 0 ? down : ''"
									style="width: 20rem; height: 20rem"></el-image>
								<span style="font-size: 12rem; color: #3c3c3c; margin-left: 8rem">{{ Number(i.compared) == 0 ? '无变化' : format(i.compared) }}</span>
							</div>
						</div>
					</div>
				</div>
				<!-- <t-result imgStyle="width: 200rem !important;" text="暂无数据" type="empty"></t-result> -->
			</div>
		</div>
		<el-button style="margin-top: 40rem" type="primary" @click="onSevr">保存</el-button>
		<el-button style="margin-top: 40rem" @click="$router.back()">返回</el-button>
		<el-button style="margin-top: 40rem" @click="onGetHistory">查看历史记录</el-button>

		<Dialog :showFooter="false" :visible.sync="visible" title="历史记录">
			<TimeLine v-loading="dialogLoading" :list="list" reverse></TimeLine>
		</Dialog>
	</div>
</template>

<script>
import Card from '@/components/Card.vue'
import img_ from '@/assets/img/photo_boy.png'
import jcxx from '../teacher-manager/img/jcxx.svg'
import zy from '../teacher-manager/img/zy.svg'
import czpg from '../teacher-manager/img/czpg.svg'
import zc from '../teacher-manager/img/zc.svg'
import ls from '../teacher-manager/img/ls.svg'
import up from '../teacher-manager/img/up.svg'
import down from '../teacher-manager/img/donw.svg'
import TResult from '@/components/Result.vue'
import Dialog from '@/components/common/Dialog.vue'
import TimeLine from '@/components/common/TimeLine.vue'
import { getHistory } from '@/api/common'

const svgReq = require.context('../teacher-manager/img', false, /\.svg$/)
const svgMap = svgReq.keys().reduce((map, key) => {
	const mod = svgReq(key)
	const name = key.replace('./', '').replace('.svg', '')
	map[name] = mod && mod.default ? mod.default : mod
	return map
}, {})

export default {
	_config: { route: { path: 'details', meta: { title: '编辑', style: 0 } } },
	data() {
		return {
			img_: img_,
			jcxx: jcxx,
			zy: zy,
			zc: zc,
			ls: ls,
			up: up,
			down: down,
			czpg: czpg,
			monthRecord: {
				work_attitude: '', // 工作态度
				lesson_preparation: '', // 备课反思
				discipline: '', // 学科辅导
				educate: '', // 育人能力
				teaching: '', // 教学能力（对应学习能力字段）
				subject_literacy: '', // 学科素养
			},
			xjList: Array.from({ length: 7 }, (_, i) => svgMap[String(i)]),
			pickerOptions: {
				disabledDate: (time) => {
					const now = new Date()
					const currentYear = now.getFullYear()
					const currentMonth = now.getMonth() + 1 // getMonth() 返回 0-11，需要加1

					// 2025年1月之前的历史月份不可选择
					const minDate = new Date('2025-01-01')

					// 禁用小于2025年1月的日期
					if (time < minDate) {
						return true
					}

					// 对于月份选择器，禁用大于当前年月的日期
					if (time.getFullYear() > currentYear) {
						return true
					}
					return time.getFullYear() === currentYear && time.getMonth() + 1 > currentMonth
				},
			},
			yearPickerOptions: {
				disabledDate: (time) => {
					const currentYear = new Date().getFullYear()
					return time.getFullYear() > currentYear
				},
			},
			tableConfig: [
				{
					prop: 'month',
					label: '月份',
					width: '80rem',
				},
				{
					prop: 'level',
					label: '等级',
				},
				{
					prop: 'final',
					label: '最终得分',
				},
				{
					prop: 'compared',
					label: '相较于上月',
				},
			],
			teacherInfo: {
				month: new Date().getFullYear() + ' ' + (new Date().getMonth() + 1).toString().padStart(2, '0'),
			},
			year: new Date(),
			tableData: [],
			yearRecord: [],
			id: null,
			dialogVisible: false,
			scores: {},
			recordData: {
				dimensional_graph: [],
				record: [],
			},
			political_type: [],
			teacherTitle: [],
			teacherEmployment: [],
			star_type: [
				{ value: 0, label: '无' },
				{ value: 1, label: '1星' },
				{ value: 2, label: '2星' },
				{ value: 3, label: '3星' },
				{ value: 4, label: '4星' },
				{ value: 5, label: '5星' },
				{ value: 6, label: '6星' },
			],
			visible: false,
			dialogLoading: false,
			list: [],
			educationLevels: [
				{ value: 7, label: '博士研究生' },
				{ value: 6, label: '硕士研究生' },
				{ value: 5, label: '本科' },
				{ value: 4, label: '专科' },
				{ value: 3, label: '高中' },
				{ value: 2, label: '初中' },
				{ value: 1, label: '小学' },
			],
			rules: {
				// 生成公共验证规则
				...(() => {
					// 字段标签映射
					const fieldLabels = {
						work_attitude: '工作态度',
						lesson_preparation: '备课反思',
						discipline: '学科辅导',
						teaching: '学习能力',
						subject_literacy: '学科素养',
						educate: '育人能力',
					}

					const validateInteger = (rule, value, callback) => {
						if (value === '' || value === null || value === undefined) {
							callback(new Error(`请输入${rule.fieldLabel}`))
							return
						}
						const n = Number(value)
						if (!Number.isInteger(n)) {
							callback(new Error('请输入 0-100 的整数'))
							return
						}
						if (n < 0 || n > 100) {
							callback(new Error('请输入 0-100 的整数'))
							return
						}
						callback()
					}

					const rules = {}
					Object.keys(fieldLabels).forEach((field) => {
						rules[field] = [
							{ required: true, message: `请输入${fieldLabels[field]}`, trigger: ['change', 'blur'] },
							{
								validator: validateInteger,
								fieldLabel: fieldLabels[field],
								trigger: ['change', 'blur'],
							},
						]
					})
					return rules
				})(),
				// 教师信息表单验证规则
				star_rating: [{ required: true, message: '请选择星级', trigger: ['change'] }],
				teaching_experience: [
					{ required: true, message: '请输入教龄', trigger: ['change', 'blur'] },
					{ type: 'number', min: 0, max: 100, message: '教龄必须在0-100之间', trigger: ['change', 'blur'] },
				],
				political_outlook: [{ required: true, message: '请选择政治面貌', trigger: ['change'] }],
				employment: [{ required: true, message: '请选择任职情况', trigger: ['change'] }],
				mobile: [
					{ required: true, message: '请输入联系方式', trigger: ['change', 'blur'] },
					{ pattern: /^1[3-9]\d{9}$/, message: '请输入正确的手机号码格式', trigger: ['change', 'blur'] },
				],
				education: [{ required: true, message: '请选择最高学历', trigger: ['change'] }],
				is_normal: [{ required: true, message: '请选择是否师范专业', trigger: ['change'] }],
				graduated_from: [
					{ required: true, message: '请输入毕业院校', trigger: ['change', 'blur'] },
					{ max: 20, message: '毕业院校长度不能超过20个字符', trigger: ['change', 'blur'] },
				],
				major: [
					{ required: true, message: '请输入所学专业', trigger: ['change', 'blur'] },
					{ max: 20, message: '所学专业长度不能超过20个字符', trigger: ['change', 'blur'] },
				],
				teacher_certificate: [{ required: true, message: '请选择是否有资格证', trigger: ['change'] }],
				teacher_title: [{ required: true, message: '请选择教师职称', trigger: ['change'] }],
			},
		}
	},
	computed: {
		// 计算最终得分
		finalScore() {
			// 检查所有评分字段是否都有值
			const requiredFields = [
				this.monthRecord.work_attitude,
				this.monthRecord.lesson_preparation,
				this.monthRecord.discipline,
				this.monthRecord.educate,
				this.monthRecord.teaching,
				this.monthRecord.subject_literacy,
			]

			// 如果有任何一个字段为空、null或undefined，则返回空
			if (requiredFields.some((field) => field === '' || field === null || field === undefined)) {
				return ''
			}

			const scores = {
				workingAttitude: Number(this.monthRecord.work_attitude), // 工作态度
				teachingReflection: Number(this.monthRecord.lesson_preparation), // 备课反思
				subjectGuidance: Number(this.monthRecord.discipline), // 学科辅导
				educationAbility: Number(this.monthRecord.educate), // 育人能力
				teachingAbility: Number(this.monthRecord.teaching), // 教学能力（对应学习能力字段）
				subjectLiteracy: Number(this.monthRecord.subject_literacy), // 学科素养
			}

			// 计算最终得分：工作态度*20% + 备课反思*15% + 学科辅导*15% + 育人能力*15% + 教学能力*20% + 学科素养*15%
			const final =
				scores.workingAttitude * 0.2 + scores.teachingReflection * 0.15 + scores.subjectGuidance * 0.15 + scores.educationAbility * 0.15 + scores.teachingAbility * 0.2 + scores.subjectLiteracy * 0.15

			return final.toFixed(2) // 确保结果总是显示两位小数，例如 xx.x0
		},
		/**
		 * 根据最终得分计算等级
		 * @description 根据教师的最终得分计算对应的等级，规则如下：
		 *              95分及以上：A
		 *              90-94分：B
		 *              80-89分：C
		 *              70-79分：D
		 *              60-69分：E
		 *              60分以下：F
		 * @returns {string} 等级字符串，如 "A", "B", "C" 等，或空字符串
		 */
		level() {
			const score = this.finalScore
			// 如果最终得分为空，等级也返回空
			if (score === '') {
				return ''
			}
			// 将字符串类型的分数转换为数字类型进行比较
			const scoreNum = Number(score)
			if (scoreNum >= 95) return 'A'
			if (scoreNum >= 90) return 'B'
			if (scoreNum >= 80) return 'C'
			if (scoreNum >= 70) return 'D'
			if (scoreNum >= 60) return 'E'
			return 'F'
		},
	},
	components: { TResult, card: Card, Dialog, TimeLine },
	methods: {
		// 处理整数输入,过滤小数点
		handleIntegerInput(field, val) {
			// 移除所有非数字字符(包括小数点)
			const intValue = val.toString().replace(/[^0-9]/g, '')
			// 限制在0-100之间
			this.monthRecord[field] = intValue === '' ? '' : Math.min(100, Math.max(0, parseInt(intValue)))
		},
		format(val) {
			const num = Number(val)
			if (!isNaN(num)) {
				return Math.abs(num).toString()
			} else {
				return val
			}
		},
		getData() {
			this.$api2
				.get('api/teacher/account/details', {
					params: {
						id: this.id,
					},
				})
				.then((res) => {
					let { data } = res.data
					this.teacherInfo = {
						...this.teacherInfo,
						...data,
					}
					this.$_axios.get('/teacher/class', { params: { id: res.data.data.id } }).then((res) => {
						let { data } = res.data
						this.tableData = data
					})
				})
		},
		/**
		 * 保存教师信息
		 * @description 提交教师信息编辑表单，包括基础信息、专业院校、职称证书等
		 * @returns {Promise<void>} 无返回值
		 */
		onSevr() {
			// 先验证教师信息表单
			this.$refs.teacherInfoForm.validate((valid1) => {
				if (valid1) {
					// 再验证月度记录表单
					this.$refs.monthRecord.validate((valid2) => {
						if (valid2) {
							this.teacherInfo.id = this.$route.query.id
							const obj = Object.assign({}, this.teacherInfo, this.monthRecord)
							obj.month = obj.month.replace(' ', '-')
							this.$api2.post('api/teacher/account/teacher-edit', obj, { logic: 1 }).then(() => {
								this.$message({
									message: '编辑成功',
									type: 'success',
								})
								this.$router.back()
							})
						} else {
							return false
						}
					})
				} else {
					this.$message.error('教师信息表单验证失败，请检查必填项')
					return false
				}
			})
		},
		onGetHistory() {
			console.log(this.teacherInfo)
			this.visible = true
			this.list = []
			this.dialogLoading = true
			getHistory('clerk_data', this.id)
				.then((res) => {
					const { list } = res.data
					this.list = list.map((i) => ({ content: i.change_detail }))
				})
				.finally(() => (this.dialogLoading = false))
		},
		getMonthRecord() {
			this.$_axios2.get('api/teacher/evaluate/month-record', { params: { id: this.id, month: this.teacherInfo.month.replace(' ', '-') } }).then((res) => {
				this.monthRecord = res.data.data
			})
		},
		/**
		 * 获取年度评估记录
		 * @description 根据教师ID和年份获取年度评估记录列表
		 * @returns {Promise<void>} 无返回值
		 */
		getYearRecord() {
			// 确保传递给接口的是年份字符串，而不是Date对象
			const yearParam = typeof this.year === 'object' ? this.year.getFullYear() : this.year
			this.$_axios2.get('api/teacher/evaluate/year-record', { params: { id: this.id, year: yearParam } }).then((res) => {
				this.yearRecord = res.data.data
				console.log(this.yearRecord)
			})
		},
		changeMonth() {
			this.getMonthRecord()
		},
		changeYear() {
			this.getYearRecord()
		},
	},
	mounted() {
		this.id = this.$route.query.id
		this.getData()
		this.$_axios2.get('api/account/political-type').then((res) => {
			this.political_type = res.data.data
		})

		this.$_axios2.get('api/1v1/sys-config/get', { params: { key: 'teacher_title' } }).then((res) => {
			this.teacherTitle = res.data.data
		})
		this.$api2.get('api/1v1/sys-config/get?key=teacher_employment').then((res) => {
			this.teacherEmployment = res.data.data
		})
		this.getMonthRecord()
		this.getYearRecord()
	},
}
</script>

<style lang="scss" scoped>
.router-view {
	background: #f7f7f7 !important;
	padding-right: 24rem;
}

.teacher-info {
	display: flex;
	flex-wrap: wrap;
	justify-content: space-between;
}

.base-info {
	width: 1616rem;
	min-height: 454rem;
	background: #ffffff;
	border-radius: 8rem;
	padding: 24rem;

	.avatar {
		height: 100rem;
		margin-left: 16rem;
		display: flex;
		align-items: center;
	}

	.info {
		flex: 1;
		font-size: 14rem;
		display: flex;
		flex-direction: column;
		justify-content: space-between;
		margin-left: 160rem;
		margin-top: 18rem;

		.name {
			margin-top: 20rem;
			//margin-bottom: 40rem;
		}

		.vitae {
			display: grid;
			grid-template-columns: repeat(3, 30%);

			.row {
				line-height: 20rem;
				display: flex;

				.key {
					width: 88rem;
					margin-right: 20rem;
					color: #888888;
					height: 38.1rem;
					display: flex;
					align-items: center;
				}

				.val {
					color: #3c3c3c;
				}
			}
		}
	}
}

.info {
	flex: 1;
	font-size: 14rem;
	display: flex;
	flex-direction: column;
	justify-content: space-between;
	margin-top: 18rem;

	.name {
		margin-top: 20rem;
		//margin-bottom: 40rem;
	}

	.vitae {
		display: grid;
		grid-template-columns: repeat(3, 33.33333333%);
		grid-row-gap: 24rem;

		.row {
			line-height: 20rem;
			display: flex;

			.key {
				width: 88rem;
				margin-right: 20rem;
				color: #888888;
				height: 38.1rem;
				display: flex;
				align-items: center;
			}

			.val {
				color: #3c3c3c;
				display: flex;
				align-items: center;
			}
		}
	}
}

.credentials {
	width: 1616rem;
	display: flex;
	justify-content: space-between;
	margin-top: 24rem;
}

.credentials-item {
	padding: 24rem;
	height: 210rem;
	flex: 1;
}

.credentials-item-key {
	color: #888888;
	height: 38.1rem;
	display: flex;
	align-items: center;
}

.credentials-item-key-left {
	width: 84rem;
}

.credentials-item-key-right {
	width: 116rem;
}

.credentials-item-val {
	color: #3c3c3c;
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
	width: 60rem;
	display: block;
	line-height: 38.1rem;
}

.echarts-radar-box {
	width: 1050rem;
	height: 286rem;
	background: #ffffff;
	border-radius: 8rem;
	padding: 24rem;
	display: flex;
	flex-direction: column;
}

.chart {
	width: 320rem;
	height: 306rem;
}

.score-list {
	flex: 1;
	display: flex;
	flex-direction: column;
	justify-content: space-between;
	align-items: center;
	font-weight: 400;
	font-size: 13rem;
	color: #555555;
	padding: 20rem 0;
}

.history-evaluation-record {
	width: 542rem;
	height: 286rem;
	background: #ffffff;
	border-radius: 8rem;
	padding: 24rem;
}

::v-deep .el-table thead tr th.is-leaf {
	border: 0 solid #ebeef5;
	border-right: none;
}

::v-deep .el-table {
	border: 0;

	th,
	tr,
	td {
		border: 0;
	}

	&::before {
		height: 0;
	}

	&::after {
		width: 0;
	}

	.el-table__fixed:before {
		height: 0;
	}
}

::v-deep .el-table,
.el-table__expanded-cell {
	background-color: #fff;
	color: #3c3c3c;
}

::v-deep .el-table tr {
	background-color: #fff !important;
}

::v-deep .el-form-item {
	margin: 0 5rem !important;
}

::v-deep .el-table tr {
	background-color: transparent !important;
}

::v-deep .el-table--striped {
	background: #fff;
}

.t-result {
	padding: 0 !important;
}

.find {
	color: #1c4efd;
	font-weight: 600;
	font-size: 12rem;
	font-style: normal;
	text-transform: none;
}

::v-deep .el-input {
	width: 220rem !important;
}
</style>
